import type { PartialMessages } from "../messages";

export const es: PartialMessages = {
  "status.syncing": "Sincronizado",
  "status.connecting": "Conectando",
  "status.full": "Lleno",
  "status.closed": "Desconectado",
  "toast.connecting": "Conectando…",
  "toast.reconnecting": "Se perdió la conexión. Reintentando…",
  "toast.retrying": "Se reintentará en breve.",
  "toast.busy": "Hay mucha carga ahora mismo",
  "notice.mapChanged": "{name} cambió el mapa",

  "hint.place": "Haz clic para colocar y arrastra para orientar (Esc para cancelar)",

  "kind.objective": "Objetivo",
  "kind.rally": "Reunión",
  "kind.enemy": "Enemigo",
  "kind.loot": "Botín",
  "kind.extract": "Extracción",
  "kind.danger": "Peligro",
  "kind.self": "Yo",
  "kind.ping": "¡Aquí!",
  "hint.objective": "Adónde vais",
  "hint.rally": "Punto de reunión",
  "hint.enemy": "Oriéntalo hacia donde lo viste",
  "hint.loot": "Contenedores raros, cadáveres",
  "hint.extract": "La extracción prevista",
  "hint.danger": "Minas, francotiradores, campo abierto",
  "hint.self": "Tu posición. Volver a ponerla borra la anterior",
  "hint.ping": "Marca temporal que desaparece a los 25 segundos",

  "tool.clearMine": "Borrar los míos",
  "tool.clearMineHint": "Quita todas las marcas que has puesto",

  "sidebar.map": "Mapa (para todos)",
  "sidebar.styleSvg": "Ilustrado",
  "sidebar.styleTile": "Satélite",
  "sidebar.floors": "Planta (solo cambia tu vista)",
  "sidebar.groundFloor": "Planta baja",
  "sidebar.floorNote": "Las marcas de otras plantas se ven atenuadas.",
  "sidebar.members": "{count} en la sala",
  "sidebar.you": "tú",
  "sidebar.guest": "invitado",
  "sidebar.clearAll": "Borrar todas las marcas",
  "sidebar.openWindow": "Abrir en una ventana (solo yo)",
  "sidebar.invite": "Invitar a alguien",
  "sidebar.help": "Cómo se usa",
  "sidebar.feedback": "Enviar comentarios",
  "sidebar.mapData": "Datos del mapa",
  "sidebar.license": "Licencia",
  "sidebar.licenseNote": "solo uso no comercial",
  "sidebar.room": "Sala",

  "pin.facing": "Orientación",
  "pin.floor": "Planta",
  "pin.map": "Mapa",
  "pin.noFacing": "Sin orientación",
  "pin.facingValue": "{compass} ({degrees}°)",
  "pin.notePlaceholder": "Añade una nota (p. ej., ventana del tercer piso)",
  "pin.removeMine": "Eliminar esta marca",
  "pin.removeOther": "Eliminar la marca de otro",
  "pin.close": "Cerrar",
  "compass.n": "N", "compass.ne": "NE", "compass.e": "E", "compass.se": "SE",
  "compass.s": "S", "compass.sw": "SO", "compass.w": "O", "compass.nw": "NO",

  "handoff.title": "Abrir en una ventana",
  "handoff.lede":
    "Un enlace para ti. Abre la misma sala en el navegador, de modo que Discord siga mostrando la pantalla compartida mientras el mapa queda en otra pantalla.",
  "handoff.open": "Abrir en el navegador de este ordenador",
  "handoff.or": "En otro dispositivo",
  "handoff.codeHint": "En ese dispositivo entra en {host}/j/ e introduce el código de arriba.",
  "handoff.copy": "Copiar enlace",
  "handoff.copied": "Copiado",
  "handoff.copyFailed": "Seleccionado arriba: pulsa Ctrl+C",
  "handoff.expiry": "Este enlace sirve una sola vez. Caduca en {time}.",
  "handoff.warn":
    "No se lo pases a nadie: al abrirlo se consume. Para eso usa «Invitar a alguien».",
  "handoff.creating": "Creando el enlace…",
  "handoff.failed": "No se pudo crear el enlace",

  "invite.title": "Invitar a alguien",
  "invite.lede":
    "Trae a alguien que no esté en el canal de voz. Escribirá un nombre y podrá poner marcas.",
  "invite.copy": "Copiar enlace",
  "invite.warn": "Cualquiera con este enlace puede entrar. No lo publiques.",
  "invite.budget": "Quedan {left} personas, caduca en {time} (usado {used}/{max}).",
  "invite.revoke": "Anular este enlace ahora",
  "invite.revoked": "Enlace anulado.",
  "invite.creating": "Creando el enlace…",
  "invite.failed": "No se pudo crear el enlace",
  "invite.revokeFailed": "No se pudo anular",

  "join.title": "Entrar en el mapa",
  "join.lede":
    "Te han invitado al mapa de una incursión. Elige un nombre para mostrar; aparecerá en tus marcas.",
  "join.name": "Nombre",
  "join.go": "Entrar",
  "join.joining": "Entrando…",
  "join.failed": "No se pudo entrar",

  "feedback.title": "Escribir al autor",
  "feedback.request": "Sugerencia",
  "feedback.bug": "Fallo",
  "feedback.other": "Otro",
  "feedback.requestHint": "Estaría bien que…",
  "feedback.bugHint": "Algo no va bien",
  "feedback.otherHint": "Cualquier cosa",
  "feedback.placeholder":
    "p. ej., quiero trazar líneas y no solo flechas / en Streets no cambian las plantas",
  "feedback.note": "Se envían tu nombre de Discord y tu ID para poder responderte.",
  "feedback.send": "Enviar",
  "feedback.sending": "Enviando…",
  "feedback.sent": "Enviado. ¡Gracias!",
  "feedback.failed": "No se pudo enviar",

  "time.minutes": "{n} min",
  "time.hoursMinutes": "{h} h {m} min",

  "error.roomFull": "Esta sala está llena",
  "error.tooManyWindows": "Demasiadas ventanas abiertas en esta sala. Cierra una.",
  "error.serverFull": "El servidor está lleno",
  "error.session": "Tu sesión ya no es válida. Vuelve a abrirla.",
  "error.handoffSpent":
    "Ese enlace no funciona. Es de un solo uso y solo para quien lo creó. Para traer a alguien, crea un enlace de invitación desde el mapa.",
  "error.inviteSpent": "Este enlace de invitación ya no sirve. Pide uno nuevo.",
  "error.inviteNotOwner": "Solo quien creó el enlace puede anularlo",
  "error.noRoom": "No se indicó ninguna sala",
  "error.needName": "Escribe un nombre",
  "error.tooShort": "Escribe un poco más, por favor",
  "error.tooLong": "Es demasiado largo",
  "error.badKind": "Categoría no válida",
  "error.rateLimited": "Demasiados mensajes. Espera unos 10 minutos.",
  "error.busy": "Hay mucha carga. Inténtalo dentro de un momento.",
  "error.sendFailed": "No se pudo enviar. Inténtalo más tarde.",
  "error.feedbackClosed": "Los comentarios están cerrados por ahora",
  "error.sessionGone": "La sesión original ha terminado. Vuelve a abrir la actividad.",

  "landing.tagline1": "Comparte un mapa de Tarkov",
  "landing.tagline2": "con todos los del canal de voz de Discord y explicadlo juntos.",
  "landing.install": "Añadir a Discord",
  "landing.installNote": "Gratis. Se abre con el icono del cohete en un canal de voz.",
  "landing.body":
    "Todos en la llamada ven el mismo mapa. Un clic pone una marca y, si arrastras al ponerla, le añade una flecha de dirección: así muestras no solo dónde, sino hacia dónde.",
  "landing.point1": "Basta con estar en el mismo canal. Sin códigos que teclear",
  "landing.point2": "Los 13 mapas. Ilustrados o satélite, y las plantas",
  "landing.point3": "Las marcas se quedan, así que puedes volver a ellas",
  "landing.point4": "Quien no esté en la llamada entra con un enlace de invitación",
  "landing.footNote":
    "Nunca toca el juego. Ni archivos, ni memoria, ni nada dibujado sobre él. Cada marca la pone una persona a mano.",
  "landing.footCredit":
    "Un proyecto aficionado, gratuito. Datos de mapas de {tarkovdev} (CC BY-NC-SA 4.0). Escape from Tarkov es un producto de Battlestate Games Limited; esto es un proyecto de fans no oficial y sin relación con ellos.",
  "landing.updates": "Novedades",
  "landing.allUpdates": "Todas las novedades",

  "boot.connecting": "Conectando con Discord…",
  "boot.failedTitle": "No se pudo iniciar",
};
